import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Radium from 'radium';

import {mergeObjectWithId} from '../../../../../utils/General';
import ShowChatIcon from '../../../../../assets/ShowChatIcon';
import PlatformIcon from "../../../../../components-new/PlatformIcon";
import Translate from "../../../../../components/Translate";

const style = {
    rawWrapper: {
        ':hover': {
            cursor: 'pointer',
        },
    },
    lastCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cell: {
        height: '60px',
        padding: '0 0 0 10px',
        lineHeight: '20px',
        verticalAlign: 'middle',
        wordWrap: 'break-word'
        // borderRight: '1px solid #A4ADC1',
    },
    popup: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        padding: '20%',
        backgroundColor: 'white',
        borderRadius: '10px',
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 100,
        cursor: 'auto',
    },
    btnClose: {
        position: 'absolute',
        bottom: '20px',
        left: '45%',
        cursor: 'pointer',
        background: 'rgb(4, 62, 92)',
        border: 'none',
        color: 'rgb(255, 255, 255)',
        padding: '8px 15px',
        borderRadius: '16px',
    }
};

class TableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            isPopupOpen: false,
        };
    }

    render() {
        const {conversation, showConversationHistory, company, openTrModal} = this.props;
        const {subs: clients} = company;
        const client = mergeObjectWithId(conversation.companyId, clients);
        return (
            <tr
                className='headTable'
                style={style.rawWrapper}
                onClick={() => openTrModal(conversation, showConversationHistory)}
            >
                <td style={style.cell}>
                    {conversation.customerName}
                </td>

                <td style={style.cell}>
                    {client.name}
                </td>

                <td style={style.cell}>
                    {conversation.operatorFullName == "null null" ? "" : conversation.operatorFullName}
                </td>

                <td style={style.cell}>
                    <PlatformIcon conversation={conversation} size={30}/>
                </td>

                <td style={style.cell}>
                    <Translate text={conversation.status}/>
                </td>

                <td style={style.cell}>
                    <div className="centered-flex-container full-height">
                        <div style={{flexGrow: 1}}>
                            {moment(new Date(conversation.lastModifiedAt).getTime())
                                .format('MM.DD.YY HH:mm')}
                        </div>
                        <div className='conversationHistory'
                             style={{
                                 height: '100%',
                                 width: '60px',
                                 padding: '20px',
                                 cursor: 'pointer',
                                 WebkitBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
                                 MozBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
                                 boxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
                             }}
                             onClick={(e) => {
                                 e.stopPropagation();
                                 showConversationHistory(conversation);
                             }}
                        >
                            <ShowChatIcon
                                style={{
                                    height: '100%',
                                    width: '100%',
                                }}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        );
    }
}

TableRow.propTypes = {
    conversation: PropTypes.object.isRequired,
    showConversationHistory: PropTypes.func.isRequired,
    company: PropTypes.object.isRequired,
};

export default Radium(TableRow);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/TableRow.jsx